import { AccountNotAChapel } from "../utils/PortalPermission";
import { DOMAIN_NAMES } from "./Domain";

export const REPORT_PERMISSIONS = {
    profitAndLoss: 'profitAndLoss',
    balanceSheet:  'balanceSheet',
    aging:         'aging',
    salesActivity: 'salesActivity'
};

export const PERMISSION_MAP = {
    [DOMAIN_NAMES.FIDUCIAL_FEDERATED]: [
        {
            label: 'Profit & Loss',
            dbKey: 'profitAndLoss',
            key: REPORT_PERMISSIONS.profitAndLoss,
            choice: [
                {
                    label: 'No access',
                    value: false
                },
                {
                    label: 'Yes',
                    value: true
                }
            ]
        },
        {
            label: 'Balance sheet',
            key: REPORT_PERMISSIONS.balanceSheet,
            dbKey: 'balanceSheet',
            isUsable: AccountNotAChapel,
            choice: [
                {
                    label: 'No access',
                    value: false
                },
                {
                    label: 'Yes',
                    value: true
                }
            ]
        },
        {
            label: 'Aging',
            key: REPORT_PERMISSIONS.aging,
            dbKey: 'aging',
            choice: [
                {
                    label: 'No access',
                    value: false
                },
                {
                    label: 'Yes',
                    value: true
                }
            ]
        },
        {
            label: 'Sales activity',
            key: REPORT_PERMISSIONS.salesActivity,
            dbKey: 'salesActivity',
            choice: [
                {
                    label: 'No access',
                    value: false
                },
                {
                    label: 'Yes',
                    value: true
                }
            ]
        }
    ],
    [DOMAIN_NAMES.FIDUCIAL]: [],
    [DOMAIN_NAMES.FIDUCIAL_JADE]: [] 
};
